import React, { useState } from 'react';
import StatusUpdatePopup from '../components/StatusUpdatePopup';
import { StatusChip } from '../components/StatusUpdatePopup';

const MOCK_TASK = {
  task_id: 'demo-001',
  title: 'Activate FASTag for Suresh Motors — Tumkur Road',
  status: 'in_progress',
  verifier_id: '',
  attachment_required: false,
};

const MOCK_TASK_ATT = {
  task_id: 'demo-002',
  title: 'Submit FASTag Settlement Report — Q4',
  status: 'in_progress',
  verifier_id: '',
  attachment_required: true,
};

const MOCK_USER = { id: 'u0', role: 'admin' };

export default function StatusUpdatePreview() {
  const [open, setOpen]         = useState(true);
  const [demoStatus, setDemoStatus] = useState('in_progress');
  const [withAtt, setWithAtt]   = useState(false);

  const statuses = ['open', 'in_progress', 'pending_verification', 'closed', 'rejected'];
  const activeTask = withAtt
    ? { ...MOCK_TASK_ATT, status: demoStatus }
    : { ...MOCK_TASK,     status: demoStatus };

  return (
    <div className="min-h-screen bg-slate-100 flex flex-col items-center justify-center gap-8 p-6">
      <div className="text-center">
        <h1 className="text-xl font-bold text-slate-800">Status Update Popup — UI Preview</h1>
        <p className="text-sm text-slate-500 mt-1">New popup-based task status flow</p>
      </div>

      {/* Status chips demo */}
      <div className="bg-white rounded-2xl shadow p-6 w-full max-w-lg">
        <p className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-3">Status chips</p>
        <div className="flex flex-wrap gap-2">
          {statuses.map(s => <StatusChip key={s} value={s} />)}
        </div>
      </div>

      {/* Controls */}
      <div className="bg-white rounded-2xl shadow p-6 w-full max-w-lg space-y-4">
        <div>
          <p className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">Try from different statuses</p>
          <div className="flex flex-wrap gap-2">
            {statuses.map(s => (
              <button key={s} onClick={() => { setDemoStatus(s); setOpen(true); }}
                className="text-xs border border-slate-200 rounded-lg px-3 py-1.5 hover:bg-slate-50 transition-colors flex items-center gap-1.5">
                <StatusChip value={s} size="xs" />
                <span className="text-slate-500">→ update</span>
              </button>
            ))}
          </div>
        </div>
        <div className="flex items-center gap-3 pt-1 border-t border-slate-100">
          <p className="text-xs font-semibold text-slate-500 uppercase tracking-wide">Attachment required</p>
          <button
            onClick={() => setWithAtt(p => !p)}
            className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors ${withAtt ? 'bg-amber-500' : 'bg-slate-200'}`}
          >
            <span className={`inline-block h-3.5 w-3.5 rounded-full bg-white shadow transition-transform ${withAtt ? 'translate-x-4' : 'translate-x-1'}`} />
          </button>
          <span className="text-xs text-slate-400">{withAtt ? 'ON — try selecting "Pending Review"' : 'OFF'}</span>
        </div>
      </div>

      <StatusUpdatePopup
        open={open}
        onClose={() => setOpen(false)}
        task={activeTask}
        currentUser={MOCK_USER}
        onSubmit={async (status, remark) => {
          alert(`Would update to: ${status}\nRemark: ${remark || '(none)'}`);
        }}
      />

      {!open && (
        <button onClick={() => setOpen(true)}
          className="bg-amber-600 text-white px-5 py-2.5 rounded-xl text-sm font-semibold hover:bg-amber-700 transition-colors shadow">
          Reopen Popup
        </button>
      )}
    </div>
  );
}
